module.exports = __webpack_public_path__ + "img/tnc-cup-client-sample.005b2346.png";